import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  logOutApi,
  commissionByStructureApi,
  commissionStructureDetailsApi,
  commissionByTeamMemberDashboardApi,
  commissionTeamMemberHistoryApi,
  commissionGroupDashboardApi,
  commissionGroupDetailsApi,
} from "../../../../Context/api";
import { statusCodes } from "../../../../Constants/generalConfig";
import { Notifications } from "../../../../App";
import { Navigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

const useCommission = () => {
  const { userInfo } = useContext(Notifications);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [commissionByStructureList, setCommissionByStructureList] = useState(
    []
  );
  const [commStructureDetailsList, setCommStructureDetailsList] = useState([]);
  const [teamMemberHistoryList, setTeamMemberHistoryList] = useState([]);
  const [commGroupList, setCommGroupList] = useState([]);
  const [commGroupDetailsList, setCommGroupDetailsList] = useState([]);
  const [byTeamList, setByTeamList] = useState([]);
  const [activeTab, setActiveTab] = useState("structure");
  const [spinner, setSpinner] = useState(false);
  const [formData, setFormData] = useState({});
  // const [filter, setFilter] = useState({
  //   days: "THIS_MONTH",
  //   modelType: null,
  //   assignTo: null,
  // });

  const [searchParams, setSearchParams] = useSearchParams();
  const [filter, setFilter] = useState({
    days: searchParams.get("days") || "THIS_MONTH",
    modelType: searchParams.get("modelType") || null,
    assignTo: searchParams.get("assignTo") || null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // const handleChangeFilter = (e) => {
  //   const { name, value } = e.target;
  //   setFilter((prev) => ({ ...prev, [name]: value }));
  // };

  const handleChangeFilter = (e) => {
    const { name, value } = e.target;

    const updated = { ...filter, [name]: value };
    setFilter(updated);

    const params = {};
    if (updated.days) params.days = updated.days;
    if (updated.modelType) params.modelType = updated.modelType;
    if (updated.assignTo) params.assignTo = updated.assignTo;

    setSearchParams(params);
  };

  const resetFilters = () => {
    const resetState = {
      days: "THIS_MONTH",
      modelType: null,
      assignTo: null,
    };

    setFilter(resetState);

    // IMPORTANT: clear URL params
    setSearchParams({ days: "THIS_MONTH" }, { replace: true });
  };

  // useEffect(() => {
  //   if (activeTab === "structure") {
  //     commissionListAPI();
  //   }
  //   if (activeTab === "member") {
  //     ByTeamMemberDashboardListAPI();
  //   }
  //   if (activeTab === "group") {
  //     commissionGroupDashboard();
  //   }
  // }, [filter.days,filter.modelType, filter.assignTo, activeTab]);


  const handleDownloadAll = () => {
    if (activeTab === "structure") {
      commissionListAPI(true);
    } else if (activeTab === "member") {
      ByTeamMemberDashboardListAPI(true);
    } else if (activeTab === "group") {
      commissionGroupDashboard(true);
    } else {
      toast.info("Download is not available");
    }
  };

const handleDownloadCommissionDetails = (commId, groupId) => {
  commissionStructureDetailsAPI(commId, groupId, true);
};

const handleDownloadTeamMemberDetails = (staffId) => {
  teamMemberHistoryListAPI(staffId, true);
};

const handleDownloadGroupDetails = (groupId) => {
  commissionDetails(groupId, true);
};

  const logOutFun = () => {
    axios
      .post(
        logOutApi(),
        {
          deviceId: userData.deviceId,
          userId: userData?.userId,
          type: "WEBPROVIDER",
        },
        { headers: { Authorization: `Bearer ${userData?.token}` } }
      )
      .then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          localStorage.removeItem("userData");
          Navigate("/");
        }
      });
  };

  const commissionListAPI = (isDownloadExcel = false) => {
    const normalize = (val) =>
      val === "" || val === "null" || val === undefined ? null : val;
    const data = {
      days: normalize(filter.days),
      modelType: normalize(filter.modelType),
      assignTo: normalize(filter.assignTo),
      isDownloadExcel: isDownloadExcel,

    };
    setSpinner(true);
    axios
      .post(
        commissionByStructureApi(),
        { ...data },
        { headers: { Authorization: `Bearer ${userData?.token}` } }
      )
      .then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          setSpinner(false);
          if (isDownloadExcel) {
            window.open(resp.data.data.fileName);
          } else {
            setCommissionByStructureList(resp.data.data);
          }
        } else if (resp.data.code === statusCodes.tokenExpire) {
          logOutFun();
        } else {
          toast.error(resp.data.message);
          setSpinner(false);
        }
      })
      .catch(() => {});
  };

  const commissionStructureDetailsAPI = (commId, groupId, isDownloadExcel = false) => {
    const data = {
      days: filter.days,
      assignTo: filter.assignTo,
      modelType: filter.modelType,
      commissionId: commId,
      groupId: groupId,
      isDownloadExcel,
    };
    setSpinner(true);
    axios
      .post(
        commissionStructureDetailsApi(),
        { ...data },
        { headers: { Authorization: `Bearer ${userData?.token}` } }
      )
      .then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          setSpinner(false);
           if (isDownloadExcel) {
          window.open(resp.data.data.fileName);
        } else {
          setCommStructureDetailsList(resp.data.data);
        }
        } else if (resp.data.code === statusCodes.tokenExpire) {
          logOutFun();
        } else {
          toast.error(resp.data.message);
          setSpinner(false);
        }
      })
      .catch(() => {});
  };

  const ByTeamMemberDashboardListAPI = (isDownloadExcel = false) => {
    const data = {
      days: filter.days || null,
      modelType: filter.modelType || null,
      assignTo: filter.assignTo || null,
      isDownloadExcel: isDownloadExcel,
    };
    setSpinner(true);
    axios
      .post(commissionByTeamMemberDashboardApi(), data, {
        headers: { Authorization: `Bearer ${userData?.token}` },
      })
      .then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          setSpinner(false);
                    if (isDownloadExcel) {
            window.open(resp.data.data.fileName);
          } else setByTeamList(resp.data.data);
          
        } else if (resp.data.code === statusCodes.tokenExpire) {
          logOutFun();
        } else {
          toast.error(resp.data.message);
          setSpinner(false);
        }
      })
      .catch(() => {});
  };

  const teamMemberHistoryListAPI = (id,  isDownloadExcel = false) => {
    setSpinner(true);
    const payload = {
      staffId: id,
      days: filter.days,
      assignTo: filter.assignTo,
      modelType: filter.modelType,
      isDownloadExcel,
    };
    axios
      .post(commissionTeamMemberHistoryApi(), payload, {
        headers: { Authorization: `Bearer ${userData?.token}` },
      })
      .then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          setSpinner(false);
          if (isDownloadExcel) {
          window.open(resp.data.data.fileName);
        } else {
          setTeamMemberHistoryList(resp.data.data);
        }
        } else if (resp.data.code === statusCodes.tokenExpire) {
          logOutFun();
        } else {
          toast.error(resp.data.message);
          setSpinner(false);
        }
      })
      .catch(() => {});
  };

  const commissionGroupDashboard = (isDownloadExcel = false) => {
    const data = {
      days: filter.days || null,
      modelType: filter.modelType || null,
      assignTo: filter.assignTo || null,
      isDownloadExcel: isDownloadExcel,
    };
    setSpinner(true);
    axios
      .post(commissionGroupDashboardApi(), data, {
        headers: { Authorization: `Bearer ${userData?.token}` },
      })
      .then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          setSpinner(false);
          if (isDownloadExcel) {
            window.open(resp.data.data.fileName);
          } else setCommGroupList(resp.data.data);
          
        } else if (resp.data.code === statusCodes.tokenExpire) {
          logOutFun();
        } else {
          toast.error(resp.data.message);
          setSpinner(false);
        }
      })
      .catch(() => {});
  };

  const commissionDetails = (id, isDownloadExcel = false) => {
    setSpinner(true);
    const data = {
      groupId: id,
      days: filter.days,
      assignTo: filter.assignTo,
      modelType: filter.modelType,
      isDownloadExcel,
    };
    axios
      .post(commissionGroupDetailsApi(), data, {
        headers: { Authorization: `Bearer ${userData?.token}` },
      })
      .then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          setSpinner(false);
           if (isDownloadExcel) {
          window.open(resp.data.data.fileName);
        } else {
          setCommGroupDetailsList(resp.data.data);
        }
        } else if (resp.data.code === statusCodes.tokenExpire) {
          logOutFun();
        } else {
          toast.error(resp.data.message);
          setSpinner(false);
        }
      })
      .catch(() => {});
  };

  return {
    data: {
      spinner,
      commissionByStructureList,
      formData,
      activeTab,
      commStructureDetailsList,
      filter,
      byTeamList,
      teamMemberHistoryList,
      commGroupList,
      commGroupDetailsList,
      searchParams,

    },
    method: {
      handleChange,
      setActiveTab,
      commissionStructureDetailsAPI,
      handleChangeFilter,
      resetFilters,
      teamMemberHistoryListAPI,
      commissionDetails,
      commissionListAPI,
      ByTeamMemberDashboardListAPI,
      commissionGroupDashboard,
      handleDownloadAll,
      handleDownloadGroupDetails,
      handleDownloadTeamMemberDetails,
      handleDownloadCommissionDetails
    },
  };
};

export default useCommission;
